module.exports = __webpack_public_path__ + "img/upload-file-name-icon.fc175869.svg";